import React from 'react'
import clsx from 'clsx'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
}) => {
  const { pathname } = useLocation()
  const history = useHistory()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { aside } = config

  const handleClick = () => {
    window.location.reload()
  }

  // Check if the current page pathname matches the 'to' prop
  const shouldReload = pathname === to

  return (
    <div className='menu-item'>
      <Link
        className={clsx('menu-link without-sub', { active: isActive })}
        to={to}
        onClick={shouldReload ? handleClick : undefined} // Conditionally attach onClick handler
      >
        {hasBullet && (
          <span className='menu-bullet' style={{ fontWeight: 'bold', color: 'black' }}>
            <span className='bullet bullet-dot' style={{ backgroundColor: '#F15625' }}></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title' style={{ fontWeight: 'bold', color: 'black' }}>
          {title}
        </span>
      </Link>
      {children}
    </div>
  )
}

export { AsideMenuItem }

// import React from 'react'
// import clsx from 'clsx'
// import {Link,useHistory} from 'react-router-dom'
// import {useLocation} from 'react-router'
// import {checkIsActive, KTSVG} from '../../../helpers'
// import {useLayout} from '../../core'

// type Props = {
//   //onClick:string
//   to: string
//   title: string
//   icon?: string
//   fontIcon?: string
//   hasBullet?: boolean
// }

// const AsideMenuItem: React.FC<Props> = ({
//   //onClick,
//   children,
//   to,
//   title,
//   icon,
//   fontIcon,
//   hasBullet = false,
// }) => {
//   const {pathname} = useLocation()
//   const isActive = checkIsActive(pathname, to)
//   const {config} = useLayout()
//   const {aside} = config

//   return (
//     <div className='menu-item'>
//       <Link className={clsx('menu-link without-sub', {active: isActive})} to={to}>
//         {hasBullet && (
//           <span className='menu-bullet' style={{fontWeight:"bold",color:'black'}}>
//             <span className='bullet bullet-dot'  style={{ backgroundColor: '#F15625' }}></span>
//           </span>
//         )}
//         {icon && aside.menuIcon === 'svg' && (
//           <span className='menu-icon'>
//             <KTSVG path={icon} className='svg-icon-2' />
//           </span>
//         )}
//         {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
//         <span className='menu-title' style={{fontWeight:"bold", color:'black'}}  >{title}</span>
//       </Link>
//       {children}
//     </div>
//   )
// }

// export {AsideMenuItem}